import EditHolidayTempModal from './containers/EditHolidayTempModal'

export default EditHolidayTempModal
